'use strict';

wbApp.directive('wbCompensationCourseLookup', ['$http', '$translate', '$timeout',
    function ($http, $translate, $timeout) {
        function formatResult(course, container) {
            if (!course) { return; }

            var compAllowed = course.compensationGroupID === compGroupID ||
                   (!!acceptingGroups && acceptingGroups.indexOf(course.compensationGroupID) !== -1);

            var html;
            if (!compAllowed && compOverride) {
                html  = "<div class='row' style='width:500px' disabled>";
                html += "<div class='col-md-10 text-danger' disabled>" + course.fullName + "</div>";
                html += "<div class='col-md-2 text-danger' disabled>" + course.amends + "</div>";
                html += "</div>";
            } else {
                html  = "<div class='row' style='width:500px'>";
                html +=   "<div class='col-md-10'>" + course.fullName + "</div>";
                html +=   "<div class='col-md-2'>" + course.amends + "</div>";
                html += "</div>";
            }

            return html;                    
        }

        function formatSelection(course) {
            if (!course || course.length === 0) {
                return null;
            }

            var compAllowed = course.compensationGroupID === compGroupID ||
                   (!!acceptingGroups && acceptingGroups.indexOf(course.compensationGroupID) !== -1);

            if (!compAllowed) {
                return "<span class='text-danger'>" + course.fullName + "</span>";
            } else {
                return course.fullName;
            }
        }

        var selection_data = [];
        var acceptingGroups = [];
        var compGroupID = -1;
        var compOverride = false;

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: '=',
                studentId: '=',
                semesterId: '=',
                compGroupId: '=',
                compOverride: '=',
                acceptingGroups: '=',
                lessonEndDate: '='
            },
            priority: 1,
            replace: true,
            template: "<input class='form-control' />",
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_COURSE'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        minimumResultsForSearch: -1,
                        allowClear: false,
                        data: selection_data
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    scope.$watch('studentId', function (current, old) {
                        if (!current) {
                            $(elm).select2('data', []);
                        } else {
                            $http({
                                method: 'GET',
                                url: "Api/Courses/GetCompensationCourses",
                                params: {
                                    semesterID: scope.semesterId,
                                    studentID: current,
                                    courseID: controller.$viewValue,
                                    lessonEndDate: scope.lessonEndDate
                                }
                            })
                            .success(function (data, status, headers, config) {
                                selection_data.length = 0;
                                for (var i = 0; i < data.length; i++) {
                                    selection_data.push(data[i]);
                                }

                                if (!controller.$viewValue && scope.compGroupId) {
                                    for (var i = 0; i < data.length; i++) {
                                        var compAllowed = data[i].compensationGroupID === compGroupID ||
                                            (!!scope.acceptingGroups && scope.acceptingGroups.indexOf(data[i].compensationGroupID) !== -1);
                                        if (compAllowed) {
                                            controller.$setViewValue(data[i].id);
                                        } else {
                                            if (!scope.compOverride) {
                                                data[i].disabled = true;
                                            }
                                        }
                                    }
                                }

                                if (controller.$viewValue) {
                                    elm.select2('val', controller.$viewValue);
                                }
                            });
                        }
                    }, true);

                    scope.$watch('compGroupId', function (value) {
                        compGroupID = value;
                    });

                    scope.$watch('acceptingGroups', function (value) {
                        acceptingGroups = value;
                    });

                    scope.$watch('compOverride', function (value) {
                        compOverride = value;
                    })

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind('select2-selecting', function (event) {
                        var compAllowed = event.object.compensationGroupID === compGroupID ||
                            (!!scope.acceptingGroups && scope.acceptingGroups.indexOf(event.object.compensationGroupID) !== -1);

                        if (!compAllowed && !scope.compOverride) {
                            event.preventDefault();
                        }
                    });

                }, 1);
            }
        }
    }]);
